import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-query-redirect',
  template: '',
})
export class QueryRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.router.navigate(['/auth/login'], {
      queryParams: this.route.snapshot.queryParams,
      replaceUrl: true,
    });
  }
}
